"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RandomizationRandomGroupCodeMaxLen = exports.RandomizationRandomGroupLabelMaxLen = exports.RandomizationStratificationCodeMaxLen = exports.RandomizationStratificationLabelMaxLen = exports.RandomizationStraticifaionCodeMaxLen = exports.RandomizationStraticifaionLabelMaxLen = exports.SignatureMaxLen = exports.IntegerMaxLen = exports.TextDefaultMaxLen = exports.DecimalMaxLen = exports.EdcAppendableTableRowValueForUnStriked = exports.EdcAppendableTableRowValueForStriked = exports.EdcAppendableTableRowStrikeAttrKeySuffix = exports.EdcAppendableTableRowCount = exports.EdcAttrKeySuffixDelimiter = exports.EdcGroupId = exports.InitialItemSequence = exports.InitialVisitSequence = exports.DummyEdcCommon = void 0;
exports.DummyEdcCommon = "DummyEdcCommon";
exports.InitialVisitSequence = 1;
exports.InitialItemSequence = 1;
exports.EdcGroupId = "EDC";
exports.EdcAttrKeySuffixDelimiter = "$$";
exports.EdcAppendableTableRowCount = "CUNT";
exports.EdcAppendableTableRowStrikeAttrKeySuffix = "STRK";
exports.EdcAppendableTableRowValueForStriked = 1;
exports.EdcAppendableTableRowValueForUnStriked = 0;
exports.DecimalMaxLen = 65;
exports.TextDefaultMaxLen = 1024;
exports.IntegerMaxLen = 10;
exports.SignatureMaxLen = 256;
// TODO, 아래 2개 상수 오타 제거 필요
exports.RandomizationStraticifaionLabelMaxLen = 255;
exports.RandomizationStraticifaionCodeMaxLen = 16;
exports.RandomizationStratificationLabelMaxLen = 255;
exports.RandomizationStratificationCodeMaxLen = 16;
exports.RandomizationRandomGroupLabelMaxLen = 255;
exports.RandomizationRandomGroupCodeMaxLen = 16;
//# sourceMappingURL=common.js.map